import React, { createContext, useContext, useReducer } from 'react';

// Define action types
const ACTIONS = {
    SET_PAGE: 'SET_PAGE',
    SET_TEMPLATE: 'SET_TEMPLATE', 
    SET_USER_WORDS: 'SET_USER_WORDS',
    SET_TRANSITIONING: 'SET_TRANSITIONING',
    RESET_APP: 'RESET_APP'
};

// Initial state
const initialState = {
    currentPage: 'cover', // 'cover', 'wordlist', 'story', 'print'
    currentTemplate: null,
    userWords: {},
    isTransitioning: false
};

// Reducer function
function appReducer(state, action) {
    switch (action.type) {
        case ACTIONS.SET_PAGE:
            return {
                ...state,
                currentPage: action.payload
            };
        case ACTIONS.SET_TEMPLATE:
            return {
                ...state,
                currentTemplate: action.payload
            };
        case ACTIONS.SET_USER_WORDS:
            return {
                ...state,
                userWords: action.payload
            };
        case ACTIONS.SET_TRANSITIONING:
            return {
                ...state,
                isTransitioning: action.payload
            };
        case ACTIONS.RESET_APP:
            return {
                ...initialState
            };
        default:
            return state;
    }
}

// Create context
const AppContext = createContext();

// Custom hook to use the context
export const useAppContext = () => {
    const context = useContext(AppContext);
    if (!context) {
        throw new Error('useAppContext must be used within an AppProvider');
    }
    return context;
};

// Context provider component
export const AppProvider = ({ children }) => {
    const [state, dispatch] = useReducer(appReducer, initialState);

    // Action creators
    const actions = {
        setPage: (page) => {
            dispatch({ type: ACTIONS.SET_PAGE, payload: page });
        },
        setTemplate: (template) => {
            dispatch({ type: ACTIONS.SET_TEMPLATE, payload: template });
        },
        setUserWords: (words) => {
            dispatch({ type: ACTIONS.SET_USER_WORDS, payload: words });
        },
        setTransitioning: (isTransitioning) => {
            dispatch({ type: ACTIONS.SET_TRANSITIONING, payload: isTransitioning });
        },
        resetApp: () => {
            dispatch({ type: ACTIONS.RESET_APP });
        },
        
        // Complex actions
        transitionToPage: (nextPage, template = null) => {
            dispatch({ type: ACTIONS.SET_TRANSITIONING, payload: true });
            setTimeout(() => {
                dispatch({ type: ACTIONS.SET_PAGE, payload: nextPage });
                if (template) {
                    dispatch({ type: ACTIONS.SET_TEMPLATE, payload: template });
                }
                dispatch({ type: ACTIONS.SET_TRANSITIONING, payload: false });
            }, 600);
        }
    };

    const value = {
        ...state,
        ...actions
    };

    return (
        <AppContext.Provider value={value}>
            {children}
        </AppContext.Provider>
    );
};